import * as React from 'react';
import { useSelector } from 'react-redux';
import { getResidentialComplexById } from '../../selectors';
import { IApplicationState } from '../../types/redux';
import { ResidentialComplexCard as ResidentialComplexCardComponent } from '../../components/ResidentialComplexCard';
import { Promo } from '../Promo';
import { ComplexImage } from '../ComplexImage';
import { Title } from '../Title';
import { FinishLabel } from '../FinishLabel';
import { MinPriceLabel } from '../MinPriceLabel';
import { SubwayInfo } from '../SubwayInfo';

interface IResidentialComplexCardProps {
  id: number;
}

export function ResidentialComplexCard(props: IResidentialComplexCardProps) {
  const { id } = props;
  const complex = useSelector((state: IApplicationState) => getResidentialComplexById(state, id));
  const publicUrl = complex.publicUrl || '#';

  return (
    <ResidentialComplexCardComponent
      url={publicUrl}
      promo={<Promo label={complex.promoLabel} />}
      image={<ComplexImage imgUrl={complex.imgUrl} />}
      title={<Title title={complex.title} />}
      finishLabel={<FinishLabel label={complex.finishInfo?.label} />}
      minPrice={<MinPriceLabel price={complex.minPrice} />}
      subwayInfo={
        <SubwayInfo
          title={complex.undegroundInfo?.title}
          color={complex.undegroundInfo?.lineColor}
          timeToSubway={complex.undegroundInfo?.timeDisplay}
        />
      }
    />
  );
}
